import { createStyles } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },

      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        width: '100%',
        height: '100%',
      },

      body: {
        height: '100%',
        width: '100%',
      },

      '#root': {
        width: '100%',
        height: '100%',
        position: 'relative',
      },
    },
  }),
);

export default useStyles;
